import * as yup from "yup";


const defaultCountry = {
    country_name: 'United States',
    country_code: 'US',
    country_language: 'en',
};

export type ScrappingFormData = yup.InferType<typeof schema>;

export const schema = yup.object().shape({
    keywords: yup.array().of(yup.string().required("Keyword is required")).min(1, "At least one keyword is required").required("Keywords are required"),
    selectedCountry: yup.array().of(yup.object().shape({
        country_name: yup.string().required("Country name is required"),
        country_code: yup.string().required("Country code is required"),
        country_language: yup.string().required("Country language is required"),
    })).min(1, "At least one country is required").required("At least one country is required"),
    frequency: yup.string().required("Frequency is required"),
    device: yup.array().of(yup.string().required()).min(1, "At least one device is required").required("At least one device is required"),
    platform_scraping: yup.array().of(yup.string().required()).min(1, "At least one platform is required").required("At least one platform is required"),
});

export const defaultValues = {
    keywords: [] as string[],
    selectedCountry: [defaultCountry],
    platform_scraping: [] as string[],
    frequency: '5 min',
    device: ['desktop'],
};



export const marks = [
    { value: 5, label: '5 min' },
    { value: 10, label: '10 min' },
    { value: 30, label: '30 min' },
    { value: 60, label: '60 min' },
    { value: 120, label: '2 hours' },
    { value: 240, label: '4 hours' },
    { value: 480, label: '8 hours' },
    { value: 600, label: 'daily' },
];
